

export  const Answer=[
    ["1",
   
     "dummy",
     "ans",
     "dummy",
     "dummy"
],
    ["2",
    "ans",
        "dummy",
        "dummy",
        "dummy"
    ],["3",
    "ans",
        "dummy",
        "dummy",
        "dummy"
    ],
       ["4",
       "ans",
        "dummy",
        "dummy",
        "dummy"
       ],
       
]

